import React from 'react';
import { Storage } from 'Pages/private/storage/cloud';
import { V2ThemeProvider } from '../_shared/V2Layout';

export const StorageV2 = () => (
  <V2ThemeProvider>
    <Storage />
  </V2ThemeProvider>
);
